import HeaderBanner from "../../../components/HeaderBanner";
import { MouData } from "./MouData";
import React from "react";

const tableData = [
  ["Sebiz Infotech Pvt. Ltd., Mohali", "Big Data Analytics"],
  ["Dream Weavers Edutract Pvt. Ltd", "B.Voc on Job Training"],
  ["Red Hat Academy", "Linux Administration"],
  ["O7 Services Pvt. Ltd  Mohali", "B.Voc on Job Training"],
  ["Securehack Pvt. Ltd. Mohali", "Cyber Security"],
  [
    "Rubicon Barclays Life Skill Program(1st Semester students)",
    "Life skill education Program",
  ],
  [
    "IBM Skill Development Edunet Foundation (CSR of IBM)",
    "Skill Build Classes",
  ],
  [
    "Amazon AWS(either in 3rd or 4th semester) (Online Cloud)",
    "Cloud Foundations",
  ],
  ["AptiGuide Institute , Jalandhar", "Aptitude Skills"],
  ["PHD Chamber of Commerce and Industry, New Delhi", "IPR Filing & Patent"],
  ["Kubotor Pvt. Ltd", "Cyber Security"],
  ["Karo Sambhav Pvt. Ltd", "E-Waste Management"],
  ["Kreativan Technologies, Chandigarh", "Skill Development"],
  ["Thinknext, Mohali", "B.Voc on Job Training"],
  ["Hoping Minds, Mohali", "B.Voc on Job Training"],
  ["Elite Web Technologies, Panchkula, Haryana", "Internship & Skill Build"],
  ["Excellence Technology, Mohali", "Internship & Skill Build"],
  ["TechCADD,Jalandhar", "Internship & Skill Build"],
  ["CS Soft Solution (I) Pvt. Ltd.", "Internship & Skill Build"],
  ["M/S Future Finders, Mohali, Punjab, India", "Internship & Skill Build"],
  ["Iniz Solutions, Jalandhar", "Internship & Skill Build"],
  ["GTB Computer Education, Jalandhar", "Internship & Skill Build"],
  ["Omninos Technologies, Mohali", "Internship & Skill Build"],
  ["Sensation Software Solutions Pvt. Ltd", "Internship & Skill Build"],
  ["Solitaire Infosys Pvt. Ltd, Mohali", "Internship & Skill Build"],
  ["Elleen Infotech Private Limited, Jalandhar", "Internship & Skill Build"],
  [
    "GNA Gears Ltd. Mehtiana",
    "For Internship of B.Tech., Industrial Visit, On –Job training of B.Voc. and Training",
  ],
  ["Cargo Motors", "B.Voc on Job Training"],
  ["NHS Hospital Jalandhar", "Research and Training Medical Health Sciences"],
  ["Apex Diagnostic Centre, Jalandhar", "Research and Training"],
  [
    "Krsnaa Diagnostics Mohali Private Limited",
    "Training Medical Health Sciences",
  ],
  ["Shrimann SuperSpeciality Hospital Jalandhar", "Internship & Training"],
  ["Ghai Hospital, Jalandhar", "Training & Placement"],
  ["Maharaj Agrasen University (HP)", "For faculty and Student exchange"],
  ["The Lions Club", "Outreach and Extension Activities"],
];

const IndustryMOUs = () => {
  document.title = "Industry MOUs";

  return (
    <div>
      <div>
        <HeaderBanner
          bgImage="IndustryBanner"
          title="MOU / Industry Partners"
          currentPage="MOU / Industry Partners"
        />
        <div className="bannerBotttom h-[3.5rem] w-full"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 mt-5">
        <div className="grid grid-cols-3 md:grid-cols-4 gap-x-1 gap-y-5">
          {MouData?.map((item, index) => (
            <div key={index}>
              <img
                src={item?.image}
                alt="images"
                className="border border-red-500"
              />
            </div>
          ))}
        </div>

        {/* Table Section */}
        <div className="overflow-x-auto mt-10">
          <table className="min-w-full border border-gray-300 text-sm md:text-base">
            <thead className="bg-gray-100">
              <tr>
                <th className="border border-gray-300 px-4 py-2">Sr. No.</th>
                <th className="border border-gray-300 px-4 py-2">MOU</th>
                <th className="border border-gray-300 px-4 py-2">
                  Programs undertaken
                </th>
              </tr>
            </thead>
            <tbody>
              {tableData.map(([mou, program], idx) => (
                <tr key={idx} className="hover:bg-gray-50">
                  <td className="border border-gray-300 px-4 py-2 text-center">
                    {idx + 1}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">{mou}</td>
                  <td className="border border-gray-300 px-4 py-2">
                    {program}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default IndustryMOUs;
